import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent.vue?vue&type=template&id=528691a6"
import script from "./RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports